import React, { useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select as MaterialSelect,
  Theme
} from "@mui/material";
import { NativeSelectProps } from "./native-select.types";

export const MenuItemType = {
  GROUP_NAME: "groupName",
  SUB_ITEM: "subItem"
};

const useStyles = makeStyles()((theme: Theme) => ({
  error: {
    color: theme.palette.error.main
  },
  menuItemGroupOption: {
    fontWeight: theme.typography.fontWeightBold
  },
  menuItemSubOption: {
    marginLeft: theme.spacing(2)
  }
}));

export const NativeSelect: React.FC<React.PropsWithChildren<NativeSelectProps>> = ({
  id,
  value,
  onChange,
  onBlur,
  label,
  items,
  required,
  disabled,
  error,
  disableEmpty,
  variant,
  ...rest
}) => {
  const helperText = error;

  const { classes } = useStyles();
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const classMenuItem = useCallback(
    (itemType?: string) => {
      if (itemType === MenuItemType.GROUP_NAME) {
        return classes.menuItemGroupOption;
      } else if (itemType === MenuItemType.SUB_ITEM) {
        return classes.menuItemSubOption;
      }
      return "";
    },
    [classes.menuItemSubOption, classes.menuItemGroupOption]
  );

  return (
    <FormControl variant="filled" fullWidth>
      <InputLabel htmlFor={id} variant={variant}>
        {label}
      </InputLabel>
      <MaterialSelect
        fullWidth
        native
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        inputProps={{
          id: id
        }}
        disabled={disabled}
        error={!!error}
        aria-describedby={helperTextId}
        variant={variant}
        {...rest}
      >
        {!disableEmpty && <option aria-label="None" value="" />}
        {items.map((item, index) => {
          return item?.value ? (
            <option
              value={item.value}
              key={`${item.value}-${index}-${item.label}`}
              className={classMenuItem(item?.type)}
            >
              {item.label}
            </option>
          ) : (
            <option disabled key={`separator-${index}`}>
              ──────────
            </option>
          );
        })}
      </MaterialSelect>
      {helperText && (
        <FormHelperText id={helperTextId} className={classes.error}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
